module.exports = __webpack_public_path__ + "img/icon-globe-light.1abfd960.svg";